import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles((t: typeof theme) => ({
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  errorMessage: {
    color: t.red01,
  },
}))
